import {
  MilestoneStatusName,
  useMilestoneDetailCardQuery
} from 'generated/graphql';

import React from 'react';

export interface IData {
  id: string;
  title: string;
  description: string;
  start: string;
  startDate?: string;
  end: string;
  duration: number;
  status: MilestoneStatusName;
}

export function useQuery(id: string) {
  const tuple = useMilestoneDetailCardQuery({
    variables: {
      id
    },
    skip: id === ''
  });

  return React.useMemo(
    () => {
      const data: IData = {
        id: tuple.data?.milestone?.id ?? '',
        title: tuple.data?.milestone?.title ?? '',
        description: tuple.data?.milestone?.description ?? '',
        start: tuple.data?.milestone?.startDate?.toFormat('DDDD') ?? '',
        startDate: tuple.data?.milestone?.startDate?.toFormat('DDDD') ?? '',
        end: tuple.data?.milestone?.endDate?.toFormat('DDDD') ?? '',
        duration: tuple.data?.milestone?.durationInDays ?? 0,
        status: tuple.data?.milestone?.status.name ?? 'open'
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
